import * as React from 'react';
import s from './menu-item.scss';
import { Box, SidebarSectionItem } from 'wix-style-react';
import { AppMarketLink } from '../app-market-link';
import { composer } from '../../component-decorators/composer';
import { biLogger } from '../../bi';
import { config } from '../../config';
export var MenuItem = composer()
    .withMarketplaceStore()
    .compose(function (_a) {
    var path = _a.path, name = _a.name, slug = _a.slug, index = _a.index, marketplaceStore = _a.marketplaceStore, holidayColor = _a.holidayColor;
    var storeRoute = marketplaceStore.route;
    var isSelected = storeRoute.slug === slug && storeRoute.path === path;
    var route = path + "/" + slug;
    var navigateTo = function () {
        biLogger.appMarketMenuNavigation({
            menu_item_label: name,
            index: index,
        });
        config.goto({
            path: path,
            slug: slug,
            referral: 'menu_navigation',
        });
    };
    return (React.createElement(Box, { className: s.menuItem },
        React.createElement(SidebarSectionItem, { dataHook: slug + "-menu-item", onClick: navigateTo, selected: isSelected },
            React.createElement(AppMarketLink, { to: route, className: holidayColor ? s.menuItemLinkHoliday : s.menuItemLink },
                React.createElement(Box, { align: "space-between", verticalAlign: "middle" }, name)))));
});
//# sourceMappingURL=menu-item.js.map